export const PROPERTY_MODAL_CONTAINER_CLASS = 'property-modal-container'
